exports = module.exports = require("../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-image-pro--wrapper{font-weight:700;display:inline-block;background-repeat:no-repeat;vertical-align:middle;background-position:50%}", ""]);

// exports
